module.exports = __webpack_public_path__ + "static/media/reporting.26f21da1.svg";